import { render, staticRenderFns } from "./MsgElementArticle.vue?vue&type=template&id=d65dce3c&scoped=true"
import script from "./MsgElementArticle.vue?vue&type=script&lang=js"
export * from "./MsgElementArticle.vue?vue&type=script&lang=js"
import style0 from "./MsgElementArticle.vue?vue&type=style&index=0&id=d65dce3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65dce3c",
  null
  
)

export default component.exports